import { ENV_VARS } from 'ENV_CONFIG';

export const getAccessToken = () => {
  if (ENV_VARS.REACT_APP_AUTH0_ENABLED === 'true') {
    return window.auth0?.getTokenIfAuthenticated();
  }
  return fetch(`${ENV_VARS.REACT_APP_SIGN_IN_HOST}/access-token`, {
    credentials: 'include',
    method: 'GET',
  })
    .then((response) => response.text())
    .then((value) => value);
};
